<script setup lang="ts">
import { useConfigStore } from '~/store/useConfigStore'
import { initializeIrWebsite } from '~/composables/initializeIrWebsite'

const config = useConfigStore()
initializeIrWebsite({ index: true })
</script>

<template>
  <NuxtLayout :name="config.$state.websiteLayout">
    <NuxtLoadingIndicator color="var(--primary-color)" />
    <NuxtPage />
  </NuxtLayout>
</template>
